<template>
  <div class="Success">
    <top-page-title>Успешно регистрирана поръчка</top-page-title>
    <section class="section bg-grey-lightest py-12">
      <div class="container">
        <underlined-heading color="orange">
          Поръчката Ви бе успешно регистрирана и се обработва.
        </underlined-heading>
        <div>
          <router-link
            :to="{ name: 'profile.view' }"
            class="button is-red is-filled mt-8"
          >
            Прегледай списък със закупени билети
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import UnderlinedHeading from '@/components/core/UnderlinedHeading'
/**
 * @module Success
 */
export default {
  name: 'Success',
  components: { UnderlinedHeading },
  data () {
    return {}
  }
}
</script>

<style lang='scss'>
@import '~utils';

</style>
